// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

export interface QuickProductLookupPageStyles {
    page?: MobiusPageProps;
}

export const quickProductLookupPageStyles: QuickProductLookupPageStyles = {};
const styles = quickProductLookupPageStyles;

const QuickProductLookupPage = ({ id }: PageProps) => (
    <Page data-test-selector="quickProductLookupPage" {...styles.page}>
        <Zone contentId={id} zoneName="Content" />
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: QuickProductLookupPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
    },
};

export default pageModule;

export const QuickProductLookupPageContext = "QuickProductLookupPage";
